<template>
<b-button-toolbar justify
                  class="motwheader">
      <b-button-group>
        <img @click="$emit('allBooks')"
             class="motw-icon"
             src="static/favicon.svg">
        <b-dropdown variant="link"
                    @click="$emit('allBooks')"
                    class="motw-ddown-librarians shadow-none caret-off"
                    text="☰"
                    no-caret>
          <b-dropdown-item @click="$emit('saveDefaultView')">Save '{{ defaultView }}' as the default view.</b-dropdown-item>
        </b-dropdown>
        <b-dropdown text="LIBRARIANS"
                    variant="link"
                    class="motw-ddown-librarians shadow-none"
                    @show="getLibrarians()">
          <b-dropdown-item-button v-for="librarian in librarians" :key="librarian" @click="search({librarian})">{{ librarian }}</b-dropdown-item-button>
        </b-dropdown>
      </b-button-group>
      <b-button pill
                class="motw-show"
                variant="link"
                @click="$emit('switchView')">{{ show }}</b-button>

      <a class="motw-bookmark align-text-middle float-right" href="https://wwww.memoryoftheworld.org">MEMORY OF THE WORLD</a>
  </b-button-toolbar>
</template>

<script>
    import {
        eventBus
    } from '../main';

    export default {
        props: [
            'show',
            'defaultView'
        ],
        data: function() {
            return {
                librarians: []
            }
        },
        methods: {
            getLibrarians() {
                this.$http.get("/librarians/on")
                    .then(response => {
                        console.log(response.data._items)
                        this.librarians = response.data._items.sort()
                    })
            },
            search(query) {
                let librarian = query.librarian
                this.$store.state.searchQuery = {
                    'endpoint': `/search/librarian/${librarian.toLowerCase()}`,
                    'status': `librarian: ${librarian}`
                }
                eventBus.$emit('reloadSearch')
            }
        },
    }
</script>

<style>
    @media (max-width: 767px) {
        .motw-bookmark {
            display: none;
        }
    }

    .motw-icon {
        background-color: #f00;
        max-height: 2.9em;
        max-width: 3.8em;
        padding-left: 0.4em;
        padding-right: 0.2em;
    }

    .motw-show {
        color: #007bff !important;
        font-weight: bold;
        text-align: center !important;
        background-color: white !important;
    }

    .motw-show:hover,
    .motw-show:visited,
    .motw-show:active,
    .motw-show:focus {
        color: #007bff !important;
        background-color: white !important;
    }

    .motwheader {
        margin-bottom: 0.4em;
        margin-top: 0.3em;
    }

    .motw-home {
        color: white;
        height: 0;
        padding: 0 0 0 0;
        border: 1.2em solid red;
        line-height: 0.2em;
        font-size: 1.2em;
        font-weight: bold;
    }

    .motw-home:hover {
        color: white;
        text-decoration: underline;
    }

    .motw-bookmark {
        color: white;
        height: 0;
        padding: 0 1.2em 0 0;
        border: 1.2em solid red;
        line-height: 0.2em;
        border-right-color: transparent;
        font-size: 1.2em;
        font-weight: bold;
    }

    .motw-bookmark:hover {
        color: white;
        height: 0;
        padding: 0 1.2em 0 0;
        line-height: 0.2em;
        border-right-color: transparent;
        font-size: 1.2em;
        font-weight: bold;
    }

    .caret-off::before {
        display: none;
    }

    .caret-off::after {
        display: none;
    }
</style>



// WEBPACK FOOTER //
// src/components/MotwHeader.vue